import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import ErrorBoundary from "@/components/ErrorBoundary";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Home from "@/pages/Home";
import Journeys from "@/pages/Journeys";
import JourneyDetail from "@/pages/JourneyDetail";
import Watch from "@/pages/Watch";
import Library from "@/pages/Library";
import Mentors from "@/pages/Mentors";
import Profile from "@/pages/Profile";
import Certificate from "@/pages/Certificate";
import Plans from "@/pages/Plans";
import PaymentReturn from "@/pages/PaymentReturn";
import Sobre from "@/pages/Sobre";
import Contato from "@/pages/Contato";
import Termos from "@/pages/Termos";
import Privacidade from "@/pages/Privacidade";
import Certificados from "@/pages/Certificados";

import AdminRoute from "@/components/AdminRoute";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminJourneys from "@/pages/admin/Journeys";
import AdminMentors from "@/pages/admin/Mentors";
import AdminCategories from "@/pages/admin/Categories";
import AdminUsers from "@/pages/admin/Users";
import AdminPlans from "@/pages/admin/Plans";
import AdminRevenue from "@/pages/admin/Revenue";
import AdminPages from "@/pages/admin/Pages";
import AdminLibrary from "@/pages/admin/Library";
import AdminHome from "@/pages/admin/Home";

function RootRoute() {
    const { user, loading } = useAuth();
    if (loading) return <div className="min-h-screen flex items-center justify-center font-body text-[#5C5C5C]">Carregando...</div>;
    return user ? <Navigate to="/inicio" replace /> : <Landing />;
}

function App() {
    return (
        <div className="App">
            <ErrorBoundary>
                <AuthProvider>
                    <BrowserRouter>
                        <ScrollToTop />
                        <Routes>
                        <Route path="/" element={<RootRoute />} />
                        <Route path="/home" element={<Landing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/cadastro" element={<Register />} />
                        <Route path="/jornadas" element={<Journeys />} />
                        <Route path="/jornada/:slug" element={<JourneyDetail />} />
                        <Route path="/biblioteca" element={<Library />} />
                        <Route path="/mentores" element={<Mentors />} />
                        <Route path="/planos" element={<Plans />} />
                        <Route path="/sobre" element={<Sobre />} />
                        <Route path="/contato" element={<Contato />} />
                        <Route path="/termos" element={<Termos />} />
                        <Route path="/privacidade" element={<Privacidade />} />
                        <Route path="/certificados" element={<Certificados />} />
                        <Route path="/conta/pagamento" element={<ProtectedRoute><PaymentReturn /></ProtectedRoute>} />

                        <Route path="/inicio" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                        <Route path="/assistir/:slug/:moduleId" element={<ProtectedRoute><Watch /></ProtectedRoute>} />
                        <Route path="/perfil" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                        <Route path="/certificado/:id" element={<ProtectedRoute><Certificate /></ProtectedRoute>} />

                        <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
                        <Route path="/admin/home" element={<AdminRoute><AdminHome /></AdminRoute>} />
                        <Route path="/admin/jornadas" element={<AdminRoute><AdminJourneys /></AdminRoute>} />
                        <Route path="/admin/mentores" element={<AdminRoute><AdminMentors /></AdminRoute>} />
                        <Route path="/admin/categorias" element={<AdminRoute><AdminCategories /></AdminRoute>} />
                        <Route path="/admin/usuarios" element={<AdminRoute><AdminUsers /></AdminRoute>} />
                        <Route path="/admin/planos" element={<AdminRoute><AdminPlans /></AdminRoute>} />
                        <Route path="/admin/receita" element={<AdminRoute><AdminRevenue /></AdminRoute>} />
                        <Route path="/admin/paginas" element={<AdminRoute><AdminPages /></AdminRoute>} />
                        <Route path="/admin/biblioteca" element={<AdminRoute><AdminLibrary /></AdminRoute>} />

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
            </ErrorBoundary>
        </div>
    );
}

export default App;
